<!-- @format -->

<ng-container *transloco="let t">
  <fudis-section [title]="t('PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.PAYMENT_FAILED')" [level]="1" [classes]="'fudis-mt-xxl'">
    <fudis-section-content>
      <fudis-body-text>
        {{ t("PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.PAYMENT_FAILED_DESCRIPTION") }}
      </fudis-body-text>
    </fudis-section-content>
  </fudis-section>
</ng-container>
